import DropdownButton from '../dropdown/dropdownButton';
import DropdownMenuButton from '../dropdown/dropdownMenuButton';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors, Icons, IRupSelectItem } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		dropdown: {
			position: 'relative',
			margin: '0.1875rem',

			'&.dropdown--with-separator::after': {
				position: 'absolute',
				top: 0,
				bottom: 0,
				right: 0,
				margin: 'auto',
				content: '""',
				width: '1px',
				height: '0.8rem',
				opacity: 1,
				backgroundColor: Colors.neutral500
			},
			'&.dropdown--with-separator:hover::after': {
				opacity: 0
			}
		},
		dropdownBtn: {
			height: '1.75rem !important',
			lineHeight: '1.75rem !important',
			padding: '0 0.5rem !important'
		}
	})
);

export interface IDropdownSelectButtonProps {
	value?: string;
	options: IRupSelectItem[];
	disabled?: boolean;
	testId?: string;
	withSeparator?: boolean;
	style?: React.CSSProperties;
	onChange?: (value: string) => void;
	menuProps?: {
		maxHeight?: string;
		width?: string;
		style?: React.CSSProperties;
		className?: string;
	};
}

const DropdownSelectButton: React.FC<IDropdownSelectButtonProps> = props => {
	const classes = useStyles();
	const dropdownText = props.options.find(o => o.value === props.value)?.text ?? (props.value || ' ');

	const onDropdownItemSelected = (item: IRupSelectItem) => {
		if (item.value === props.value) {
			return;
		}

		props.onChange && props.onChange(item.value);
	};

	return (
		<div
			className={clsx(classes.dropdown, { 'dropdown--with-separator': props.withSeparator })}
			style={props.style}
			onClick={e => e.stopPropagation()}
		>
			<DropdownButton
				disabled={props.disabled}
				className={clsx(classes.dropdownBtn, 'rup-btn--neutral', 'rup-btn--text')}
				iconSvg={Icons.DropdownArrowsIcon}
				text={dropdownText}
				testId={props.testId}
				menuProps={props.menuProps}
			>
				{props.options.map((option, index) => (
					<DropdownMenuButton
						key={index}
						testId={`${props.testId ?? 'dropdown-option'}-${index}`}
						onClick={() => onDropdownItemSelected(option)}
					>
						<span>{option.text ?? option.value}</span>
					</DropdownMenuButton>
				))}
			</DropdownButton>
		</div>
	);
};

export default DropdownSelectButton;
